<p-dialog #dialogRef [(visible)]="showDialog" [modal]="true" [style]="{width: '80vw', minWidth: '350px'}"
	[draggable]="false" [resizable]="false" [maximizable]="true" [breakpoints]="{'768px': '100vw'}"
	(onHide)="closeDialog()"
	header="{{ dialogMode === 'edit' ? ('modals.bankTransfer.editTitle' | translate) : ('modals.bankTransfer.addTitle' | translate) }}">
	<form>
		<div>
			<p-table [value]="localLines.controls" styleClass="p-datatable-sm" responsiveLayout="stack">
				<ng-template pTemplate="header">
					<tr>
						<th style="width: 150px;">{{ 'form.field.date' | translate }}</th>
						<th style="width: 180px;">{{ 'form.field.bank' | translate }}</th>
						<th style="width: 180px;">{{ 'form.field.account' | translate }}</th>
						<th style="width: 180px;">{{ 'form.field.amount' | translate }}</th>
						<th style="width: 40px;"></th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-row let-i="rowIndex">
					<tr [formGroup]="row">
						<td>
							<span class="p-column-title">{{ 'form.field.date' | translate }}</span>
							<p-calendar formControlName="date" [showIcon]="true" dateFormat="dd/mm/yy" [required]="true"
								[dataType]="'date'"
								[ngClass]="{'ng-invalid ng-dirty': (submitted || row.get('date')?.touched) && row.get('date')?.invalid}"
								[inputStyle]="{'width':'100%'}" appendTo="body"></p-calendar>
							<div *ngIf="(submitted || row.get('date')?.touched) && row.get('date')?.errors?.['required']"
								class="invalid-feedback text-danger d-block p-error">
								{{ 'form.validation.required' | translate:{field: ('form.field.date' | translate)} }}
							</div>
						</td>
						<td>
							<span class="p-column-title">{{ 'form.field.bank' | translate }}</span>
							<p-dropdown formControlName="bank" [options]="masterBank" optionValue="bank_code"
								[optionLabel]="bank_code - curentLang === 'ar' ? 'bank_name_ar' : (curentLang === 'he' ? 'bank_name_he' : 'bank_name_en')"
								placeholder="{{ 'form.field.bank' | translate }}" [showClear]="false" filter="true"
								filterBy="{{curentLang === 'ar' ? 'bank_name_ar' : (curentLang === 'he' ? 'bank_name_he' : 'bank_name_en')}},bank_code,bank_id"
								[ngClass]="{'ng-invalid ng-dirty': (submitted || row.get('bank')?.touched) && row.get('bank')?.errors}"
								appendTo="body"></p-dropdown>
							<div *ngIf="(submitted || row.get('bank')?.touched) && row.get('bank')?.errors?.['required']"
								class="invalid-feedback text-danger d-block p-error">
								{{ 'form.validation.required' | translate:{field: ('form.field.bank' | translate)} }}
							</div>
						</td>
						<td>
							<span class="p-column-title">{{ 'form.field.account' | translate }}</span>
							<input pInputText type="text" formControlName="account"
								[ngClass]="{'ng-invalid ng-dirty': (submitted || row.get('account')?.touched) && row.get('account')?.errors}" />
							<div *ngIf="(submitted || row.get('account')?.touched) && row.get('account')?.errors?.['required']"
								class="invalid-feedback text-danger d-block p-error">
								{{ 'form.validation.required' | translate:{field: ('form.field.account' | translate)} }}
							</div>
						</td>
						<td>
							<span class="p-column-title">{{ 'form.field.amount' | translate }}</span>
							<p-inputNumber formControlName="amount" locale="en-US" [minFractionDigits]="2"
								[maxFractionDigits]="2" [min]="0.01" [inputStyle]="{'width':'100%'}"
								[ngClass]="{'ng-invalid ng-dirty': (submitted || row.get('amount')?.touched) && row.get('amount')?.invalid}"
								placeholder="{{ 'form.field.amount' | translate }}"
								(onInput)="onAmountInput($event, i)"></p-inputNumber>
							<div *ngIf="(submitted || row.get('amount')?.touched) && row.get('amount')?.errors?.['required']"
								class="invalid-feedback text-danger d-block p-error">
								{{ 'form.validation.required' | translate:{field: ('form.field.amount' | translate)} }}
							</div>
							<div *ngIf="(submitted || row.get('amount')?.touched) && row.get('amount')?.errors?.['min']"
								class="invalid-feedback text-danger d-block p-error">
								{{ 'form.validation.min' | translate:{field: ('form.field.amount' | translate), min: 0.01} }}
							</div>
						</td>
						<td class="text-center">
							<span class="p-column-title"></span>
							<button type="button" pButton icon="pi pi-trash"
								class="p-button-rounded p-button-danger p-button-text"
								style="width: 2rem; height: 2rem; min-width: unset;" (click)="removeLine(i)"
								[disabled]="localLines.length <= 1"
								[title]="'modals.common.remove' | translate"></button>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="footer">
					<tr>
						<td class="d-flex justify-content-between align-items-center">
							<button type="button" pButton label="{{'modals.common.addLine' | translate}}"
								icon="pi pi-plus" class="p-button-sm p-button-outlined" (click)="addBankTransferLine()"
								[disabled]="localLines.length > 0 && localLines.at(localLines.length - 1).invalid"
								[title]="'modals.common.addLine' | translate"></button>
						</td>
						<td colspan="4" class="text-end fw-bold fs-5 pe-3">
							<span class="fw-bold text-end">
								{{ 'modals.common.total' | translate }}
							</span>
							<span>{{ displayTotalAmount | number:'1.2-2' }}</span>
						</td>
					</tr>
				</ng-template>
			</p-table>
			<div class="d-flex d-md-none justify-content-between align-items-center mt-3">
				<button type="button" pButton label="{{'modals.common.addLine' | translate}}"
					icon="pi pi-plus" class="p-button-sm p-button-outlined" (click)="addBankTransferLine()"
					[disabled]="localLines.length > 0 && localLines.at(localLines.length - 1).invalid"
					[title]="'modals.common.addLine' | translate"></button>
				<div>
					<span class="fw-bold text-end">
						{{ 'modals.common.total' | translate }}
					</span>
					<span>{{ displayTotalAmount | number:'1.2-2' }}</span>
				</div>
			</div>
		</div>
	</form>
	<ng-template pTemplate="footer">
		<button type="button" pButton label="{{'modals.common.cancel' | translate}}" icon="pi pi-times"
			class="p-button-danger" (click)="closeDialog()" [title]="'modals.common.cancel' | translate"></button>
		<button pButton type="button" class="p-button-success" label="{{'modals.common.updateLines' | translate}}"
			icon="pi pi-check" (click)="onSave()" [disabled]="localLinesInvalid && submitted">
		</button>
	</ng-template>
</p-dialog>